import {h} from 'preact';
import constants from "../../constants";

export default function CheckIcon() {
  return <svg>
    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-check"}/>
  </svg>;
}
